import Mv from "./_Mv";
import Search from "./_Search";
import AboutUs from "./_AboutUs";
import News from "./_News";
import Strength from "./_Strength";

//Mv();
Search();
AboutUs();
News();
Strength();

window.addEventListener('load', () => {
  Mv();
});